<template>
    <v-card flat tile>
    <ValidationObserver ref="observer" v-slot="{handleSubmit,invalid}">
      <form @keyup.enter="onSubmitHandler" @submit.prevent="handleSubmit(onSubmitHandler)" id="form">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            <h5 class="white--text font-weight-light">
              <slot name="title">{{title}}</slot>
            </h5>
          </v-toolbar-title>
          <v-spacer />
         <v-btn :x-small = "true" fab dark :color="'secondary'"  @click="onCloseDialogHandler">
          <v-icon>close</v-icon>
        </v-btn>
        </v-toolbar>

       <v-card-text>
          <v-responsive>
            <br>
            <v-row no-gutters>
              <v-row align="start" justify="center" no-gutters>
                <v-col cols="12">
                  <v-row align="start" justify="center" no-gutters>
                    <v-col :cols="bPoint.mdAndUp ? 6 : 12" class="pr-1">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        vid="Name"
                        rules="required"
                      >
                        <v-text-field
                          color="primary"
                          dense
                          hide-details="auto"
                          outlined
                          v-model="selectedItem.name"
                          :label="labels.name"
                          id="Name"
                          :error-messages="errors"
                        >
                        </v-text-field>
                        
                      </ValidationProvider>
                    </v-col>
                    <v-col :cols="bPoint.mdAndUp ? 6 : 12" class="pr-1">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        :name="'vehicles'"
                        vid="VehicleId"
                        rules="required"
                        >
                        <v-autocomplete
                          color="primary"
                          dense
                          hide-details="auto"
                          outlined
                          v-model="selectedItem.vehicleId"
                          :label="labels.vehicle"
                          id="vehicleId"
                          :items="select.vehicles.items"
                          :error-messages="errors"
                        ></v-autocomplete>
                        
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <v-row align="start" justify="center" no-gutters>
                    <v-col :cols="bPoint.mdAndUp ? 6 : 12" class="pr-1" v-if="selectedItem.serviceCause == 0 || selectedItem.serviceCause == 2">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        :name="'serviceCause'"
                        vid="ServiceCause"
                        rules="required"
                        >
                        <v-select
                        hide-details="auto"
                          color="primary"
                          dense
                          outlined
                          v-model="selectedItem.serviceCause"
                          :label="labels.serviceCause"
                          id="ServiceCause"
                          :items="select.serviceCauses.items"
                          :error-messages="errors"
                        ></v-select>
                        
                      </ValidationProvider>
                    </v-col>
                    <v-col v-else cols="12" class="pr-1">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        :name="'serviceCause'"
                        vid="ServiceCause"
                        rules="required"
                        >
                        <v-select
                        hide-details="auto"
                          color="primary"
                          dense
                          outlined
                          v-model="selectedItem.serviceCause"
                          :label="labels.serviceCause"
                          id="ServiceCause"
                          :items="select.serviceCauses.items"
                          :error-messages="errors"
                        ></v-select>
                        
                      </ValidationProvider>
                    </v-col>
                    <v-col :cols="bPoint.mdAndUp ? 6 : 12" class="pr-1"
                        v-if="selectedItem.serviceCause == 0 || selectedItem.serviceCause == 2">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        :name="'frequencyPeriod'"
                        vid="FrequencyPeriod"
                        rules="required"
                        >
                        <v-select
                        hide-details="auto"
                          color="primary"
                          dense
                          outlined
                          v-model="selectedItem.frequencyPeriod"
                          @change="getValidPlaceHolderForFrequencyValue"
                          :label="labels.frequency"
                          id="frequencyPeriod"
                          :items="select.frequencies.items"
                          :error-messages="errors"
                        ></v-select>
                        
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <v-row align="start" justify="center" no-gutters
                        v-if="selectedItem.serviceCause == 2">
                    <v-col :cols="bPoint.mdAndUp ? 6 : 12" class="pr-1">
                      <ValidationProvider 
                        v-slot="{ validate, errors }"
                        vid="ServiceNotification"
                        rules="required"
                      >
                        <v-text-field
                        hide-details="auto"
                        type="number"
                          color="primary"
                          dense
                          outlined
                          v-model="selectedItem.serviceNotification"
                          :label="labels.notificationDays"
                          :error-messages="errors"
                          id="serviceNotification"
                        ></v-text-field>
                        
                      </ValidationProvider>
                    </v-col>
                    <v-col :cols="bPoint.mdAndUp ? 6 : 12" class="pr-1">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        vid="ServiceNotificationKilometers"
                        rules="required"
                      >
                        <v-text-field
                        hide-details="auto"
                        type="number"
                          color="primary"
                          dense
                          outlined
                          v-model="selectedItem.serviceNotificationKilometers"
                          :label="labels.serviceNotificationKilometers"
                          :error-messages="errors"
                          id="serviceNotificationKilometers"
                        ></v-text-field>
                        
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row align="start" justify="center" no-gutters
                        v-else>
                    <v-col cols="12" class="pr-1"
                      v-if="selectedItem.serviceCause == 0"
                    >
                      <ValidationProvider 
                        v-slot="{ validate, errors }"
                        vid="ServiceNotification"
                        rules="required"
                      >
                        <v-text-field
                        hide-details="auto"
                        type="number"
                          color="primary"
                          dense
                          outlined
                          v-model="selectedItem.serviceNotification"
                          :label="labels.notificationDays"
                          :error-messages="errors"
                          id="serviceNotification"
                        ></v-text-field>
                        
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" class="pr-1"
                      v-else-if="selectedItem.serviceCause==1"
                    >
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        vid="ServiceNotificationKilometers"
                        rules="required"
                      >
                        <v-text-field
                        hide-details="auto"
                        type="number"
                          color="primary"
                          dense
                          outlined
                          v-model="selectedItem.serviceNotificationKilometers"
                          :label="labels.serviceNotificationKilometers"
                          :error-messages="errors"
                          id="serviceNotificationKilometers"
                        ></v-text-field>
                        
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row align="start" justify="center" no-gutters v-if="selectedItem.serviceCause == 2 && (selectedItem.frequencyPeriod != 2 && selectedItem.isOnceOnly != true)">
                    
                    <v-col :cols="bPoint.mdAndUp ? 6 : 12" class="pr-1">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        vid="FrequencyValue"
                        rules="required|numeric"
                      >
                        <v-text-field
                        hide-details="auto"
                          color="primary"
                          dense
                          outlined
                          v-model="selectedItem.frequencyValue"
                          :label="labels.frequencyValue"
                          id="frequencyValue"
                          :error-messages="errors"
                        >
                        </v-text-field>
                        
                      </ValidationProvider>
                    </v-col>
                    <v-col :cols="bPoint.mdAndUp ? 6 : 12" class="pr-1">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        vid="MileageFrequencyValue"
                        rules="required|numeric"
                      >
                        <v-text-field
                        hide-details="auto"
                          color="primary"
                          dense
                          outlined
                          v-model="selectedItem.mileageFrequencyValue"
                           type="number"
                          :label="labels.frequencyValueKilometers"
                          id="mileageFrequencyValue"
                          :error-messages="errors"
                        >
                        </v-text-field>
                        
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row align="start" justify="center" no-gutters
                    v-else-if="selectedItem.frequencyPeriod != 2"
                  >
                    <v-col cols="12" class="pr-1" v-if="selectedItem.serviceCause == 0">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        vid="FrequencyValue"
                        rules="required|numeric"
                      >
                        <v-text-field
                        hide-details="auto"
                          color="primary"
                          dense
                          outlined
                          v-model="selectedItem.frequencyValue"
                          :label="labels.frequencyValue"
                          id="frequencyValue"
                          :error-messages="errors"
                        >
                        </v-text-field>
                        
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" class="pr-1" v-if="selectedItem.serviceCause == 1">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        vid="MileageFrequencyValue"
                        rules="required|numeric"
                      >
                        <v-text-field
                        hide-details="auto"
                          color="primary"
                          dense
                          outlined
                          v-model="selectedItem.mileageFrequencyValue"
                           type="number"
                          :label="labels.frequencyValueKilometers"
                          id="mileageFrequencyValue"
                          :error-messages="errors"
                        >
                        </v-text-field>
                        
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row align="start" justify="center" no-gutters v-if="selectedItem.serviceCause == 2 || selectedItem.serviceCause == 1">
                    <v-col :cols="bPoint.mdAndUp ? 6 : 12" class="pr-1" v-if="selectedItem.serviceCause == 1">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        vid="mileageToCalculateFrom"
                        rules="numeric"
                      >
                        <v-text-field
                        hide-details="auto"
                          color="primary"
                          dense
                          outlined
                          v-model="selectedItem.mileageToCalculateFrom"
                          :label="labels.mileageToCalculateFrom"
                          id="mileageToCalculateFrom"
                          :error-messages="errors"
                        >
                        </v-text-field>
                        
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" class="pr-1" v-else>
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        vid="mileageToCalculateFrom"
                        rules="numeric"
                      >
                        <v-text-field
                        hide-details="auto"
                          color="primary"
                          dense
                          outlined
                          v-model="selectedItem.mileageToCalculateFrom"
                          :label="labels.mileageToCalculateFrom"
                          id="mileageToCalculateFrom"
                          :error-messages="errors"
                        >
                        </v-text-field>
                        
                      </ValidationProvider>
                    </v-col>
                    <v-col :cols="bPoint.mdAndUp ? 6 : 12" class="pr-1" v-if="selectedItem.serviceCause == 1">
                        <v-switch v-model="selectedItem.isOnceOnly" class="mx-2 mt-3" :label="labels.IsOnceOnly"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row align="start" justify="center" no-gutters>
                    <v-col :cols="bPoint.mdAndUp ? 6 : 12" class="pr-1" v-if="selectedItem.serviceCause == 0 || selectedItem.serviceCause == 2">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        vid="PlannedDate"
                        rules=""
                      >
                        <VDateTextBox
                        @input="setDate"
                        v-model="selectedItem.plannedDate"
                        :labelProp="labels.plannedDate"
                        :error="errors[0]"
                        id='plannedDate'
                        :minValue="currentDay"
                        ></VDateTextBox>
                      </ValidationProvider>
                    </v-col>
                    <v-col v-if="selectedItem.serviceCause == 0 || selectedItem.serviceCause == 2" :cols="bPoint.mdAndUp ? 6 : 12" class="pr-1">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        :name="'servicetypes'"
                        vid="ServiceType"
                        rules="required"
                        >
                        <v-select
                          color="primary"
                          dense
                          outlined
                          hide-details="auto"
                          v-model="selectedItem.serviceType"
                          :label="labels.serviceType"
                          id="servicetype"
                          :items="select.servicetypes.items"
                          :error-messages="errors"
                        ></v-select>
                      </ValidationProvider>
                    </v-col>
                    <v-col v-else cols="12" class="pr-1">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        :name="'servicetypes'"
                        vid="ServiceType"
                        rules="required"
                        >
                        <v-select
                          color="primary"
                          dense
                          outlined
                          hide-details="auto"
                          v-model="selectedItem.serviceType"
                          :label="labels.serviceType"
                          id="servicetype"
                          :items="select.servicetypes.items"
                          :error-messages="errors"
                        ></v-select>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <v-row align="start" justify="center" no-gutters>
                    <v-col cols="12" class="pr-1">
                      <ValidationProvider
                        v-slot="{ validate, errors }"
                        vid="description"
                        rules=""
                      >
                        <v-textarea
                        color="primary"
                        dense
                        outlined
                        rows="3"
                        :label="labels.description"
                        v-model="selectedItem.description"
                        id="description"
                        hide-details="auto"
                        ></v-textarea>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-row>
          </v-responsive>
        </v-card-text>  
        <br>   
        <v-card-actions>
          
          <SubmitGroup
            @close="onCloseDialogHandler"
            @submit="onSubmitHandler"
            :closeOnSubmit="closeOnSubmit"
            :disabledSubmit="false"
          />
        </v-card-actions>
      </form>
    </ValidationObserver>
  </v-card>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import store from '@/store/store'
import translate from '@/utils/genTable/multilanguageHelper.js'
import {
  required,
  ext,
  numeric,
  positive,
  integer
} from 'vee-validate/dist/rules'
import VDateTextBox from '@/components/custom/VDateTextBox'
import httpClient from '@/api/httpClient'

export default {
  props: {
    identifier: integer,
    isUpdate: Boolean,
    title: String
  },
  data() {
    return {
      showDate: false,
      selectedItem: {},
      endPoint: 'serviceSchedules',
      closeOnSubmit: false,
      select: {
        vehicles: {
          items: [],
          endPoint: 'vehicles'
        },
        frequencies: {
          items: []
        },
        servicetypes: {
          items: []
        },
        serviceCauses: {
          items: []
        }
      },
      labels: {
        vehicle: this.getTranslation('Vehicles'),
        name: this.getTranslation('Name'),
        frequencyValue: this.getTranslation('Frequency value'),
        frequencyValueKilometers: this.getTranslation(
          'Service should occur every (km)'
        ),
        notificationDays: this.getTranslation(
          'Notification before service (days)'
        ),
        frequency: this.getTranslation('Frequency'),
        serviceType: this.getTranslation('Service type'),
        plannedDate: this.getTranslation('Planned Date'),
        description: this.getTranslation('Description'),
        serviceNotificationKilometers: this.getTranslation(
          'Notification before service (km)'
        ),
        serviceCause: this.getTranslation('Service cause'),
        IsOnceOnly: this.getTranslation('Is only once'),
        mileageToCalculateFrom: this.getTranslation('Mileage to calculate from')
      }
    }
  },
  components: {
    SubmitGroup: () => import('@/components/SubmitGroup'),
    ValidationProvider,
    ValidationObserver,
    VDateTextBox
  },
  methods: {
    getValidPlaceHolderForFrequencyValue() {
      if (this.selectedItem == null) {
        this.labels.frequencyValue = this.getTranslation('Frequency value')
      } else if (this.selectedItem.frequencyPeriod == 0) {
        this.labels.frequencyValue = this.getTranslation(
          'Service is planned on every (Years)'
        )
      } else if (this.selectedItem.frequencyPeriod == 1) {
        this.labels.frequencyValue = this.getTranslation(
          'Service is planned on every (Months)'
        )
      } else {
        this.labels.frequencyValue = this.getTranslation('Frequency value')
      }
    },
    formatDataToIsos(date) {
      return date.toISOString().substr(0, 10)
    },
    setDate(value) {
      this.selectedItem.plannedDate = value
    },
    onCloseDialogHandler() {
      this.$refs.observer.reset()
      this.selectedItem = {}
      this.$emit('updateDialog', false)
    },
    getTranslation(toTranslate) {
      return translate(toTranslate, 'pages.serviceSchedules')
    },
    onSubmitHandler() {
      if (this.selectedItem.frequency == 2) {
        this.selectedItem.plannedDate = null
      }
      this.handleRequest()
    },
    adaptTextForDropDown(text) {
      let adaptedText = ''
      for (let letter in text) {
        if (letter == 0) {
          adaptedText += text[letter].toUpperCase()
        } else if (text[letter] == text[letter].toUpperCase()) {
          adaptedText += ' ' + text[letter].toLowerCase()
        } else {
          adaptedText += text[letter]
        }
      }
      return adaptedText
    },
    getVehiclesSelect() {
      httpClient.get('vehicles').then(response => {
        for (const data of response.data) {
          let obj = {
            text: data.name,
            value: data.id
          }
          this.select.vehicles.items.push(obj)
        }
      })
    },
    getFrequencySelect() {
      httpClient.get('servicebookplanningfrequency').then(response => {
        for (const data of response.data) {
          let obj = {
            text: this.getTranslation(this.adaptTextForDropDown(data.name)),
            value: data.id
          }
          this.select.frequencies.items.push(obj)
        }
      })
    },
    getServiceCauseSelect() {
      httpClient.get('servicecause').then(response => {
        for (const data of response.data) {
          let obj = {
            text: this.getTranslation(this.adaptTextForDropDown(data.name)),
            value: data.id
          }
          this.select.serviceCauses.items.push(obj)
        }
      })
    },
    getServiceTypeSelect() {
      httpClient.get('servicetypes').then(response => {
        for (const data of response.data) {
          let obj = {
            text: this.getTranslation(this.adaptTextForDropDown(data.name)),
            value: data.id
          }
          this.select.servicetypes.items.push(obj)
        }
      })
    },
    setActualSelectedItem() {
      if (this.isUpdate) {
        httpClient.get(this.endPoint + '/' + this.identifier).then(response => {
          this.selectedItem = response.data
        })
      } else {
        this.selectedItem = {}
      }
    },
    handleError(error) {
      if (error.response.status == 422) {
        this.disabledSubmit = true
        this.showLoading = false
        const errorObject = {}
        for (const i of error.response.data.errors) {
          const arr = []
          const message = i.Error
          const prop = i.PropertyName
          arr.push(message)
          this.$set(errorObject, prop, arr)
        }
        this.$refs.observer.setErrors(errorObject)
      }
      if (error.response.status == 500) {
        store.dispatch(
          'notification/add',
          {
            type: 'error',
            message: 'Server error'
          },
          {
            root: true
          }
        )
      }

      throw new Error(error)
    },
    handleRequest() {
      if (this.isUpdate) {
        httpClient
          .put('serviceSchedules/' + this.selectedItem.id, this.selectedItem)
          .then(response => {
            let notification = {
              type: 'success',
              message: `Item successfully updated.`
            }
            store.dispatch('notification/add', notification, { root: true })
            this.onCloseDialogHandler()
          })
          .catch(error => {
            this.handleError(error)
          })
      } else {
        httpClient
          .post('serviceSchedules', this.selectedItem)
          .then(response => {
            let notification = {
              type: 'success',
              message: `Item successfully added.`
            }
            store.dispatch('notification/add', notification, { root: true })
            this.onCloseDialogHandler()
          })
          .catch(error => {
            this.handleError(error)
          })
      }
    }
  },
  created() {
    this.setActualSelectedItem()
    this.getVehiclesSelect()
    this.getServiceTypeSelect()
    this.getFrequencySelect()
    this.getServiceCauseSelect()
  },
  watch: {
    identifier: {
      handler() {
        this.setActualSelectedItem()
      }
    },
    isUpdate: {
      handler() {
        if (this.isUpdate == false) {
          this.selectedItem = {}
          this.$refs.observer.reset()
        }
      }
    }
  },
  computed: {
    currentDay() {
      return `${this.formatDataToIsos(new Date())} 00:00`
    },
    bPoint() {
      return this.$vuetify.breakpoint
    }
  }
}
</script>
